export default "__VITE_ASSET__BOr19o0m__"